import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FormTitle = styled.p`
  font-family: BiotifMedium;
  color: #1c1b3a;
  font-size: 22px;

  margin: 0;
  text-align: center;
`;

export const CloseIcon = styled.img`
  height: auto;
  width: 14px;
  cursor: pointer;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  background-color: #fff;
  border-radius: 15px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #fff;

  gap: 30px;
`;

export const Row = styled.div`
  display: flex;
  gap: 30px;
`;

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  flex: 1;
  max-height: 350px;
`;

export const RightContent = styled.div`
  flex: 1;
`;

export const RightContentTitle = styled.p`
  margin: 0 0 8px;
  font-size: 1.6rem;
`;

export const CardGridContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  padding: 0 50px 0 0px;
  row-gap: 30px;
  column-gap: 30px;
  height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex: 1;
  justify-content: end;
  background-color: #fff;
`;
